<template>
	<div class="portal-page about-page">
		<section class="portal-section portal-section--compact">
			<div class="portal-section__head">
				<h1>关于银合Pilot</h1>
			</div>
			<div class="about-grid">
				<div class="about-card">
					<h3>产品目标</h3>
					<p>统一财税后台、AI 办公和数字员工市场，让站点从单一后台变成完整工作入口。</p>
				</div>
				<div class="about-card">
					<h3>设计方向</h3>
					<p>整体采用浅色 new-api 控制台风格，强调轻边框、圆角、分组导航和高密度信息布局。</p>
				</div>
				<div class="about-card">
					<h3>集成能力</h3>
					<p>办公室页已通过 npm 集成 `x-sender`，后续可继续接入内部 AI 接口和自动化流程。</p>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
export default {
	name: 'About'
};
</script>
